var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "sidebar-video-recording",
          class: _vm.isSidebarMinimized ? "s-minimized" : "",
        },
        [
          _c("i", { staticClass: "c-sidebar-nav-icon cil-video" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "video-screen-recording-container items-center cursor-pointer",
            },
            [
              _c(
                "b-button-group",
                { attrs: { size: "sm" } },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: {
                        variant: "outline-info cursor-pointer",
                        title: "Start video recording",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.sendMessage(_vm.START_RECORDING)
                        },
                      },
                    },
                    [_c("b-icon", { attrs: { icon: "camera-reels" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: {
                        variant: "outline-info cursor-pointer",
                        title: "Start video and screen recording",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.sendMessage(
                            _vm.START_VIDEO_AND_SCREEN_RECORDING
                          )
                        },
                      },
                    },
                    [_c("b-icon", { attrs: { icon: "fullscreen" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: {
                        variant: "outline-info cursor-pointer",
                        title: "Start screen recording with audio only",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.sendMessage(_vm.START_SCREEN_RECORDING)
                        },
                      },
                    },
                    [_c("b-icon", { attrs: { icon: "display" } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm.recording
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true },
                            },
                          ],
                          attrs: {
                            variant: "outline-danger cursor-pointer",
                            title: "Stop recording",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.sendMessage(_vm.STOP_RECORDING, false)
                            },
                          },
                        },
                        [_c("b-icon", { attrs: { icon: "stop-circle" } })],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recordingUploading
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true },
                            },
                          ],
                          attrs: {
                            variant: "outline-info cursor-pointer",
                            title: "Uploading...",
                          },
                        },
                        [
                          _c("b-spinner", {
                            attrs: { small: "", label: "Spinning" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  attrs: {
                    variant: "outline-info cursor-pointer ml-1",
                    title: "Show recordings",
                    size: "sm",
                  },
                  on: { click: _vm.handleShowRecordingsBtn },
                },
                [
                  _vm.recordingsLoading
                    ? _c("b-spinner", {
                        attrs: { small: "", label: "Spinning" },
                      })
                    : _c("b-icon", { attrs: { icon: "folder" } }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("RecordingsListModal", {
        attrs: {
          "modal-id": _vm.globalRecordingModalId,
          recordings: _vm.recordings,
          "current-page": _vm.currentPage,
          total: _vm.recordingsCount,
        },
        on: {
          pageChanged: _vm.handlePageChanged,
          delete: _vm.handleDeletedBtn,
          close: function ($event) {
            return _vm.$bvModal.hide(_vm.globalRecordingModalId)
          },
          changeName: _vm.handleChangeName,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }